import { render } from "./AstronautsPage.vue?vue&type=template&id=85a9fa9e"
import script from "./AstronautsPage.vue?vue&type=script&lang=js"
export * from "./AstronautsPage.vue?vue&type=script&lang=js"

import "./AstronautsPage.vue?vue&type=style&index=0&id=85a9fa9e&lang=css"

import exportComponent from "/home/dms/projects/peopleinspacenow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__